{
  "maximumPrincipal": 3000000.00,
  "remainingMatchdays": 18,
  "maximumTermMatchdays": 17,
  "maturityMatchday": 27,
  "tier": "TOP",
  "ratePerMatchday": 0.010,
  "ineligibilityReason": null,
  "activeLoan": null,
  "calendar": {
    "currentMatchday": 10,
    "remainingMatchdays": 18,
    "remaining": 18,
    "totalMatchdays": 28,
    "seasonId": "00000000-0000-4000-8000-000000000101"
  }
}
